<template>
  <div class="go-in">
    <div
      class="organizational"
      :style="`height:${pageLoading ? '3rem' : 'auto'};`"
      v-loading="pageLoading"
    >
      <div style="box-sizing: border-box">
        <TitleTips
          :routerList="routerList"
          routeType="/humanResource/recruitmentInformation"
          title="招聘信息"
        />
      </div>
      <div
        style="
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          font-size: 0.16rem;
        "
      >
        <!-- <div style="display:flex;flex: 3; flex-wrap: wrap; justify-content:space-between; margin-bottom: 0.1rem;width: 100%; ">
        <ComponentProduct @click.native="clickItem(item)" width="2.72rem" v-for="(item,index) in pageData" :key="index" :imgUrl="item.imgUrl" :productName="item.productName"/>
      </div> -->
        <div style="width: 100%; display: flex; justify-content: flex-end">
          <div style="display: flex">
            <el-button
              type="text"
              style="margin-right: 0.2rem"
              :loading="downloading"
              @click="downloadTemplate"
              >下载模版</el-button
            >
            <el-upload
              class="upload-demo"
              action="#"
              :show-file-list="false"
              :http-request="uplodResume"
            >
              <el-button type="text" :loading="uploadLoading"
                >上传简历</el-button
              >
            </el-upload>
          </div>
        </div>
        <div
          style="
            width: 100%;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
          "
        >
          <div
            class="showMsgItem"
            v-for="(item, index) in pageData"
            :key="index"
          >
            <div class="work">
              <span>招聘职位：{{ item.jobName }}</span>
              <span style="margin-left: 1rem"
                >招聘人数：{{ item.peopleNumber }}</span
              >
            </div>
            <div class="workContent">
              <div style="margin-bottom: 0.3rem; font-size: 0.16rem">
                <p style="margin-bottom: 0.05rem; font-size: 14px">职位职责</p>
                <span
                  style="font-size: 12px; color: #989898; white-space: pre-line"
                  v-html="item.jobResponsibilities"
                ></span>
              </div>
              <div style="margin-bottom: 0.3rem; font-size: 0.16rem">
                <p style="margin-bottom: 0.05rem; font-size: 14px">职位要求</p>
                <span
                  style="font-size: 12px; color: #989898; white-space: pre-line"
                  v-html="item.jobRequirements"
                ></span>
              </div>
            </div>
          </div>
          <!-- <div class="showMsgItem">
          <div class="work">
            <span>招聘职位：   {{'销售经理'}}</span>
            <span style="margin-left:1rem;">招聘人数：   {{'若干'}}</span>
          </div>
          <div class="workContent">
            <div style="margin-bottom:0.3rem;font-size: 0.16rem;">
              <span style="margin-bottom:0.75rem;font-size: 14px;">职位职责</span>
              <p style="font-size:12px;color:#989898;">1、对所管辖片区内一切销售活动负责，包括市场开发、市场信息收集及分析、接受客户订单、组织合同评审、合同履约、产品质量的监控和反馈、贷款回收、逾期账款清理；</p>
            </div>
            <div style="margin-bottom:0.3rem;font-size: 0.16rem;">
              <span style="margin-bottom:0.75rem;font-size: 14px;">职位职责</span>
              <p style="font-size:12px;color:#989898;">1、对所管辖片区内一切销售活动负责，包括市场开发、市场信息收集及分析、接受客户订单、组织合同评审、合同履约、产品质量的监控和反馈、贷款回收、逾期账款清理；</p>
            </div>
          </div>
        </div> -->
        </div>
        <div
          style="margin: 0.2rem 0rem; font-size: 0.16rem; align-self: center"
        >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleTips from '../components/TitleTips.vue';
import http from '../utils/http';
export default {
  components: {
    TitleTips
  },
  name: 'ElectromechanicalComponents',
  data() {
    return {
      pageNum: 1,
      pageSize: 10,
      total: 2,
      searchLoading: false,
      pageLoading: false,
      downloading: false,
      uploadLoading: false,
      parentProductTypeList: [],
      childProductType: [],
      formData: {
        parentProductType: '机电元件及组件',
        productType: '',
        productName: ''
      },
      pageData: [],
      routerList: []
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.pageLoading = true;
      http
        .post('/reception/recruit/queryRecruitmentInfo', {
          pageSize: this.pageSize,
          pageNum: this.pageNum
        })
        .then(res => {
          this.pageData = res.rows;
          this.total = res.total;
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    searchData() {
      this.searchLoading = true;
      this.getData();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getData();
    },
    changeParentProductType(val) {
      this.childProductType = this.parentProductTypeList.filter(
        item => item.productType === val
      )[0].subCategory;
      this.formData.productType = '';
    },
    clickItem(item) {
      this.$router.push({ path: `/showProduct/productDetail/${item.id}` });
    },
    downloadTemplate() {
      this.downloading = true;
      http
        .post('/reception/homePage/getList', {
          groupType: 117,
          pageNum: 1,
          pageSize: 100
        })
        .then(res => {
          http.download(res.data[0].val, { filename: res.data[0].name });
          // var a = document.createElement('a');
          // var event = new MouseEvent('click');
          // // a.target = "_blank";
          // a.download = res.data[0].name;
          // a.href = res.data[0].val; //路径前拼上前缀，完整路径
          // a.dispatchEvent(event);
        })
        .finally(() => {
          this.downloading = false;
        });
    },
    uplodResume(file) {
      let acceptArr = ['pdf', 'doc', 'docx'];
      if (!acceptArr.includes(file.file.name.split('.')[1])) {
        this.$message.error('请上传pdf或者doc,docx的文件');
        return;
      }
      let formData = new FormData();
      // 定义传递参数第一个值为参数名 第二个为值
      formData.append('file', file.file);
      formData.append('savePath', 'redStar');
      formData.append('isOpen', 'true');
      this.uploadLoading = true;
      http
        .post('/reception/mail/upload', formData)
        .then(res => {
          this.$message.success('上传成功');
        })
        .finally(() => {
          this.uploadLoading = false;
        });
    }
  },
  mounted() {
    this.routerList = this.$route.matched;
  },

  watch: {
    // $route: {
    //   handler: function(val, oldVal){
    //     if(val!=oldVal){
    //     }
    //   },
    //   // 深度观察监听
    //   deep: true
    // }
  }
};
</script>

<style lang="scss" scoped>
// * {
//   margin: 0;
//   padding: 0;
// }

.go-in {
  .organizational {
    width: 100%;
    box-sizing: border-box;
    padding: 0rem 1rem 0rem 1rem;
    .showMsgItem {
      margin: 0.1rem 0rem;
      .work {
        box-sizing: border-box;
        padding: 0rem 0.2rem;
        color: #7f7f7f;
        font-weight: 600;
        font-size: 0.14rem;
        display: flex;
        align-items: center;
        width: 5.8rem;
        height: 0.49rem;
        border: 1px solid #ccc;
      }
      .workContent {
        box-sizing: border-box;
        padding: 0.1rem 0.2rem;
        width: 5.8rem;
        height: 2.5rem;
        overflow-y: auto;
        border: 1px solid #ccc;
        border-top: none;
      }
    }
    .box-card {
      width: 6.31rem;
    }
  }
}
</style>
